import React from "react";
import { Message } from "semantic-ui-react";
const ActivityComponent = props => {
  const { messages } = props;
  const reverseMessages = [...messages];
  reverseMessages.reverse();

  if (reverseMessages.length)
    return (
      <React.Fragment>
        {reverseMessages.slice(0, 4).map((message, key) => (
          <Message info key={key}>
            {message}
          </Message>
        ))}
      </React.Fragment>
    );
  else return <p>There are no new activity in your hotel</p>;
};

export default ActivityComponent;



// WEBPACK FOOTER //
// ./src/components/ActivityComponent.js